import * as React from 'react';
import * as classNames from 'classnames';
import { observable, computed, action } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import { IApp } from './../../../stores/AllStores';
import { toPath } from '../../../../../common/helpers/toPath';
import { PortalSearchBarField } from '../../../components/layout';

// Enumerables
enum LoginStatus {
    Default,
    LoggingIn,
    Success,
    AllFieldsRequired,
    WrongPasswordOrUsername
}

// Styles
const s = require('./Login.css');
const pacLogo = require('./../../../assets/pacific-auto-logo.png');
const pbiLogo = require('./../../../assets/pacific-best-logo.png');

// Component
@inject('store')
@observer
export class Login extends React.Component<IApp, {}> {
    constructor(props: IApp) {
        super(props);
    }

    @observable private status: LoginStatus = LoginStatus.Default;
    @observable private username: string = '';
    @observable private password: string = '';

    @computed
    private get error(): boolean {
        return this.status === LoginStatus.AllFieldsRequired || this.status === LoginStatus.WrongPasswordOrUsername;
    }

    @computed
    private get label(): string {
        return this.error
            ? this.status === LoginStatus.AllFieldsRequired
                ? 'All fields are required, try again'
                : this.status === LoginStatus.WrongPasswordOrUsername
                    ? 'Wrong password or username, try again'
                    : 'Something went wrong, try again'
            : this.status === LoginStatus.LoggingIn
                ? 'Signing in...'
                : this.status === LoginStatus.Success ? 'Signed in' : 'Sign in';
    }

    @computed
    private get redirectTo(): string {
        const { store, location } = this.props;

        let from = '/';
        if (typeof location !== 'undefined' && typeof location.state !== 'undefined') {
            if (location.state !== null && typeof location.state.from !== 'undefined') {
                from = location.state.from;
            }
        }

        return from === '/' && store.user.userType !== null ? '/' + toPath(store.user.userType) : from;
    }

    public render() {
        return (
            <div className={s.wrapper}>
                <div className={s.container}>
                    <div className={classNames(s.login, { [s.error]: this.error })}>
                        {(window &&
                            window.location &&
                            window.location.hostname &&
                            window.location.hostname.toLowerCase().indexOf('pacauto') !== -1 && (
                                <img className={s.logo} src={pacLogo} alt="Pacific Best Inc." />
                            )) ||
                            (window &&
                                window.location &&
                                window.location.hostname &&
                                window.location.hostname.toLowerCase().indexOf('pacificbest') !== -1 && (
                                    <img className={s.logo} src={pbiLogo} alt="Pacific Auto Company" />
                                ))}

                        <h1>Welcome!</h1>

                        <form onSubmit={this.handleFormSubmit}>
                            <PortalSearchBarField
                                className={s.field}
                                icon={null}
                                lightness={0}
                                field="username"
                                label="Username"
                                value={this.username}
                                onChange={this.handleFormFieldChange}
                            />

                            <PortalSearchBarField
                                className={s.field}
                                icon={null}
                                lightness={0}
                                type="password"
                                field="password"
                                label="Password"
                                value={this.password}
                                onChange={this.handleFormFieldChange}
                            />

                            <button className={s.button}>{this.label}</button>
                        </form>
                    </div>
                </div>

                {this.props.store.user.isLoggedIn && <Redirect to={{ pathname: this.redirectTo }} />}
            </div>
        );
    }

    private handleFormFieldChange = (field: 'username' | 'password', value: string) => {
        this[field] = value;
    };

    @action
    private handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const endUsername = this.username.trim();
        const endPassword = this.password.trim();

        if (endUsername === '' || endPassword === '') {
            this.status = LoginStatus.AllFieldsRequired;
        } else {
            this.handleLogin(endUsername, endPassword);
        }
    };

    @action
    private handleLogin = async (username: string, password: string) => {
        const { user } = this.props.store;

        this.status = LoginStatus.LoggingIn;

        try {
            const user = await this.props.store.user.login(username, password);
            if (user !== null && typeof user.id !== 'undefined' && user.id) {
                this.status = LoginStatus.Success;
                return user;
            } else {
                throw user;
            }
        } catch (err) {
            this.status = LoginStatus.WrongPasswordOrUsername;
            this.password = '';

            console.error(err);
            return err;
        }
    };
}

export default Login;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/user/login/Login.tsx